var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-100 top-banner"},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('img',{staticClass:"mr-1",attrs:{"src":require("@/assets/logo/gov-logo.svg")}}),_c('p',{staticClass:"mb-0"},[_vm._v("펀다에이아이 X 중소벤처기업부 ‘우리동네크라우드펀딩’")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }